module.exports = __webpack_public_path__ + "static/img/1.ebac7e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Seguro-de-mascotas/1.png
// module id = V1eI
// module chunks = 0